import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AboutV2 = () => {
  const [pedagogies, setPedagogies] = useState([]);
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/Pedagogie/all`)
      .then((response) => {
        if (response.data && response.data.data) {
          setPedagogies(response.data.data);
        }
      })
      .catch((error) => {
        console.error(
          'Erreur lors du chargement des données pédagogiques :',
          error,
        );
      });
  }, []);

  return (
    <div style={{ backgroundColor: '#f8f8f8' }}>
      <div className="container">
        <div className="section-title">
          {pedagogies.length > 0 && (
            <h3
              className="titleAbout"
              style={{ textAlign: 'center', color: 'black' }}
            >
              {pedagogies[0].PedagogieTitre}
            </h3>
          )}
        </div>
        <div className="row">
          {pedagogies.map((item, index) => (
            <div className="col-lg-4 col-md-12 mt-5 mb-5" key={index}>
              <div className="single-intro-inner style-icon-bg text-center">
                <div className="thumb">
                  <img
                    src={`${Url}/images/${item.PedagogieIcone}`}
                    alt="icone"
                  />
                </div>
                <div className="details">
                  <h5 style={{ height: '50px' }}>{item.SousTitre}</h5>
                  {/* Texte justifié */}
                  <p style={{ textAlign: 'justify' }}>
                    {item.PedagogieDescription}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutV2;
